import { CreateReducer } from "../../shared/utils/createReducer";
import {
  SET_REPORT_DRAFT_UPDATED,
  SET_REPORT_LOCK_ACQUIRED,
  SET_REPORT_LOCK_RELEASED,
  SET_CASE_ASSIGNMENT_CHANGED,
  CLEAR_CASE_ASSIGNMENT_CHANGED,
} from "../definitions/reportLockConstants";
import {
  DraftUpdatePayload,
  ReportLockUser,
  SetCaseAssignmentChangedAction,
  SetReportDraftUpdatedAction,
  SetReportLockAcquiredAction,
  SetReportLockReleasedAction,
} from "../actions/reportLockActions";

export interface ReportLockState {
  eventId: number;
  lockEvent: "acquired" | "released" | "draft_updated" | null;
  lockEventReportId: number | null;
  lockEventLockedBy: ReportLockUser | null;
  lockEventForceReleased: boolean;
  lockEventDraftUpdate: DraftUpdatePayload | null;
  assignmentChangedEventId: number;
  assignmentChangedCaseId: number | null;
  assignmentChangedIsRemoved: boolean;
}

export interface ReportLockReducerProps extends ReportLockState {}

const initState: ReportLockState = {
  eventId: 0,
  lockEvent: null,
  lockEventReportId: null,
  lockEventLockedBy: null,
  lockEventForceReleased: false,
  lockEventDraftUpdate: null,
  assignmentChangedEventId: 0,
  assignmentChangedCaseId: null,
  assignmentChangedIsRemoved: false,
};

const reportLockReducer = CreateReducer(initState, {
  [SET_REPORT_LOCK_ACQUIRED](
    state: ReportLockState,
    action: SetReportLockAcquiredAction
  ): ReportLockState {
    const { eventId, reportId, lockedBy } = action.payload;
    return {
      ...state,
      eventId,
      lockEvent: "acquired",
      lockEventReportId: reportId,
      lockEventLockedBy: lockedBy,
      lockEventForceReleased: false,
      lockEventDraftUpdate: null,
    };
  },
  [SET_REPORT_LOCK_RELEASED](
    state: ReportLockState,
    action: SetReportLockReleasedAction
  ): ReportLockState {
    const { eventId, reportId, forceReleased } = action.payload;
    return {
      ...state,
      eventId,
      lockEvent: "released",
      lockEventReportId: reportId,
      lockEventLockedBy: null,
      lockEventForceReleased: forceReleased,
      lockEventDraftUpdate: null,
    };
  },
  [SET_REPORT_DRAFT_UPDATED](
    state: ReportLockState,
    action: SetReportDraftUpdatedAction
  ): ReportLockState {
    const { eventId, draftUpdate } = action.payload;
    return {
      ...state,
      eventId,
      lockEvent: "draft_updated",
      lockEventReportId: draftUpdate.reportId,
      lockEventLockedBy: null,
      lockEventForceReleased: false,
      lockEventDraftUpdate: draftUpdate,
    };
  },
  [SET_CASE_ASSIGNMENT_CHANGED](
    state: ReportLockState,
    action: SetCaseAssignmentChangedAction
  ): ReportLockState {
    const { eventId, caseId, isRemoved } = action.payload;
    return {
      ...state,
      assignmentChangedEventId: eventId,
      assignmentChangedCaseId: caseId,
      assignmentChangedIsRemoved: isRemoved,
    };
  },
  [CLEAR_CASE_ASSIGNMENT_CHANGED](state: ReportLockState): ReportLockState {
    return {
      ...state,
      assignmentChangedEventId: 0,
      assignmentChangedCaseId: null,
      assignmentChangedIsRemoved: false,
    };
  },
});

export default reportLockReducer;
